import { render } from "./ContentLink.vue?vue&type=template&id=4c4b7c0b"
import script from "./ContentLink.vue?vue&type=script&lang=js"
export * from "./ContentLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__